import { Model, Attr } from 'spraypaint'

import ApplicationRecord from '@/models/ApplicationRecord'

@Model()
export default class SorewardsStandardRate extends ApplicationRecord {
  static jsonapiType = 'sorewards_standard_rates'

  @Attr() id!: string
  @Attr() issuePhysical!: number
  @Attr() issueVirtual!: number
  @Attr() shipUnit!: number
  @Attr() shipGrouped!: number
  @Attr() loadFlat!: number
  @Attr() loadPct!: number
}
